// Recovered compiled webpack factory 33182. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { S: () => n });
  let n = (t) => !!(t && t.getVelocity);
}
